"use client";

import React from "react";
import Link from "next/link";

const ProWhipEshop = ({ data }) => {
    if (!data) return null;

    const mainImageUrl = data?.mainImage?.media?.file;
    const buttons = data?.buttons || [];

    const resolveUrl = (btn) => {
        if (btn.externalUrl) return btn.externalUrl;
        return btn?.internalPage?.pageFolder?._url || "#";
    };

    return (
        <section className="w-full bg-[#efefef] py-24">
            <div className="max-w-6xl mx-auto px-6 text-center">

                {/* ================= MAIN IMAGE ================= */}
                {mainImageUrl && (
                    <div className="flex justify-center">
                        <div className="relative w-[600px] max-w-full aspect-[765/610]">
                            <img
                                src={mainImageUrl}
                                alt="Main Product"
                                className="w-full h-full object-contain"
                            />
                        </div>
                    </div>
                )}

                {/* ================= BUTTONS ================= */}
                {buttons.length > 0 && (
                    <div className="flex flex-wrap justify-center gap-6">
                        {buttons.map((btn, index) => {
                            const url = resolveUrl(btn);

                            const isSecondary =
                                btn.label?.toLowerCase().includes("serial");

                            return (
                                <Link key={index} href={url}>
                                    <button
                                        className={`
                      px-10 py-4 rounded-full text-sm font-medium tracking-wide transition
                      ${isSecondary
                                                ? "border bg-black text-white"
                                                : "bg-black text-white bg-gray-800"
                                            }
                    `}
                                    >
                                        {btn.label}
                                        &nbsp; <span className="text-xs">▶</span>
                                    </button>
                                </Link>
                            );
                        })}
                    </div>
                )}

            </div>
        </section>
    );
};

export default ProWhipEshop;
